import { render, staticRenderFns } from "./AdditionalRole.vue?vue&type=template&id=1fe60ad6&"
import script from "./AdditionalRole.vue?vue&type=script&lang=js&"
export * from "./AdditionalRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports